import { useStoreState, useStoreActions } from 'easy-peasy';

export function useProjects() {
  // State
  const currentProject = useStoreState((state) => state.projects.currentProject);
  const currentProjectId = useStoreState((state) => state.projects.currentProjectId);
  const loading = useStoreState((state) => state.projects.loading);
  const error = useStoreState((state) => state.projects.error);
  const assetsLoaded = useStoreState((state) => state.projects.assetsLoaded);
  const viewMode = useStoreState((state) => state.projects.viewMode);
  const isViewModeSwitched = useStoreState((state) => state.projects.isViewModeSwitched);
  const version = useStoreState((state) => state.projects.version);
  const projectLanguage = useStoreState((state) => state.projects.projectLanguage);
  const isTranslating = useStoreState((state) => state.projects.isTranslating);

  // Actions
  const setCurrentProject = useStoreActions((actions) => actions.projects.setCurrentProject);
  const setCurrentProjectId = useStoreActions((actions) => actions.projects.setCurrentProjectId);
  const clearProject = useStoreActions((actions) => actions.projects.clearProject);
  const setAssetsLoaded = useStoreActions((actions) => actions.projects.setAssetsLoaded);
  const setProjectAvatarId = useStoreActions((actions) => actions.projects.setProjectAvatarId);
  const setViewMode = useStoreActions((actions) => actions.projects.setViewMode);
  const setProjectLanguage = useStoreActions((actions) => actions.projects.setProjectLanguage);
  const setIsTranslating = useStoreActions((actions) => actions.projects.setIsTranslating);

  // Thunks
  const loadProject = useStoreActions((actions) => actions.projects.loadProject);
  const handleProjectClaim = useStoreActions((actions) => actions.projects.handleProjectClaim);

  return {
    currentProject,
    currentProjectId,
    loading,
    assetsLoaded,
    error,
    viewMode,
    version,
    isViewModeSwitched,
    projectLanguage,
    isTranslating,
    setIsTranslating,
    setProjectLanguage,
    setCurrentProject,
    setCurrentProjectId,
    clearProject,
    setAssetsLoaded,
    setProjectAvatarId,
    setViewMode,
    loadProject,
    handleProjectClaim
  };
}
